import { requestBaseService } from './index'

export const getNotification = (payload) => {
  return requestBaseService({
    url: `console/ex/v1/push-notification`,
    headers: {
      'Cache-Control': 'no-cache',
    },
    method: 'get',
    params: {
      ...payload,
      timestamp: new Date().getTime(),
      size: 10000,
    },
  })
}

export const getNotificationCountApi = () => {
  return requestBaseService({
    url: `console/ex/v1/push-notification/count-unread`,
    headers: {
      'Cache-Control': 'no-cache',
    },
    method: 'get',
    params: {
      timestamp: new Date().getTime(),
    },
  })
}

export const getNotificationCategoryApi = () => {
  return requestBaseService({
    url: `console/ex/v1/push-notification/category`,
    method: 'get',
  })
}

export const postReadAllNotificationApi = () => {
  return requestBaseService({
    url: `console/ex/v1/push-notification/read-all`,
    method: 'put',
  })
}

export const postReadNotificationApi = (id) => {
  return requestBaseService({
    url: `console/ex/v1/push-notification/read/${id}`,
    method: 'put',
  })
}

const Notification = {
  getNotification,
  getNotificationCountApi,
  getNotificationCategoryApi,
  postReadAllNotificationApi,
  postReadNotificationApi
}

export default Notification
